import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { CheckboxIcon } from "@aureskonnect/react-ui";
import { mutate } from "swr";
import { toast } from "react-toastify";
import { useSnapshot } from "valtio";
import { diff } from "deep-object-diff";

import { store } from "@components/VerticalLayout/store";
import { resetAllPeripherals } from "@pages/Applications/DeviceAssociateModal/store";
import {
    store as moneticsStore,
    setActions,
    setIsActionsClicked,
    setLimit,
} from "@pages/Peripherals/Monetics/store";

import {
    moneticIsExistInShop,
    getListMonetics,
    checkDesignationIfExist,
} from "./moneticsUtils";
import {
    getMoneticsValidationErrors,
    isMoneticsFormValid,
} from "./moneticsValidation";
import {
    buildMsSolutionAddPayload,
    buildMoneticAddPayload,
    buildMsSolutionEditPayload,
    buildMoneticEditPayload,
} from "./moneticsDataBuilder";
import { useAdyenConfig } from "./useAdyenConfig";
import { checkIpIfExist, UpdateResourceIp } from "@helpers/general";
import {
    AdyenCurrencies,
    SPEEDS,
    numberPositiveMatch,
} from "../../../../constants";
import ErrorToast from "@components/Common/ErrorTost";
import { useFetchGlobal } from "../../../../api/hooks";

type UseMoneticsApplicationFormProps = {
    setIsAddMoneticsClicked: any;
    isAddMoneticsClicked: boolean;
    setDataIsUpdated: React.Dispatch<React.SetStateAction<boolean | number>>;
    editedData: React.SetStateAction<any>;
    isAddNewMoneticsButtonClicked: boolean;
    setEditedData: Function;
    idShop: string;
    isEdited: boolean;
    setIsEdited: Function;
    selectMark: boolean;
    setSelectMark: Function;
    inputDesignation: boolean;
    setInputDesignation: Function;
    setInputIp: Function;
    InputIp: boolean;
    shopIds?: any;
    tableData?: any;
    setIsUpdateOperation: Function;
    setIpExist: Function;
    ipExist: boolean;
    isConsult: boolean;
    setIsConsult: Function;
    selectedRows: any;
    isModalAssociate?: boolean;
};

export function useMoneticsApplicationForm({
    setIsAddMoneticsClicked,
    isAddMoneticsClicked,
    setDataIsUpdated,
    editedData,
    isAddNewMoneticsButtonClicked,
    setEditedData,
    idShop,
    isEdited,
    setIsEdited,
    selectMark,
    setSelectMark,
    inputDesignation,
    setInputDesignation,
    setInputIp,
    InputIp,
    shopIds,
    tableData,
    setIsUpdateOperation,
    setIpExist,
    ipExist,
    isConsult,
    setIsConsult,
    selectedRows,
    isModalAssociate,
}: UseMoneticsApplicationFormProps) {
    const {
        userID,
        resourceIp,
        franchiseID,
        operatorID,
        shopID,
        oneShop,
    } = useSnapshot(store);
    const { isActionsClicked } = useSnapshot(moneticsStore);
    const { t } = useTranslation();
    const { fetchGlobal } = useFetchGlobal();

    const paramsTypes: {
        label: string;
        value: string;
    }[] = [t("Check"), t("Ticket restaurant"), t("Bank card")].map(
        (element: string) => {
            return {
                label: element,
                value: element,
            };
        }
    );
    const list_payment_method: {
        label: string;
        value: string;
    }[] = [
        { label: t("TPE configuration"), value: "1" },
        { label: t("payment disabled"), value: "4" },
        { label: t("payment enabled"), value: "3" },
    ];
    const paymentMethods: {
        label: string;
        value: string;
    }[] = [
        { label: "TPE configuration", value: "1" },
        { label: "payment disabled", value: "4" },
        { label: "payment enabled", value: "3" },
    ];

    const speeds: LocalOptionsType[] = SPEEDS.map((element: number) => {
        return {
            label: element,
            value: element,
        };
    });
    const ports: LocalOptionsType[] = Array.from(
        { length: 256 },
        (_, i) => "COM" + (i + 1)
    ).map((element: string) => {
        return {
            label: element,
            value: element,
        };
    });
    const uuidUser = localStorage.getItem("uuidUser");

    const typeOfConfig: {
        label: string;
        value: string;
    }[] = ["ERT 10", "ERT 45", "ERT 46", "Autre"].map((element: string) => {
        return {
            label: element,
            value: element,
        };
    });
    const typeOfTerminal: {
        label: string;
        value: string;
    }[] = [
        { label: t("Automate kiosk (Pre-authorization)"), value: "25" },
        { label: t("TPE POS (Debit)"), value: "22" },
    ];
    const pathname = window.location.pathname.toString();
    const notStartWithSpaceRegExp = new RegExp(/^\S/);

    const [portSelectInput, setPortSelectInput] = React.useState<boolean>(
        false
    );
    const [error] = React.useState(false);
    const [isNameExist, setIsNameExist] = React.useState<boolean>(false);
    const [SelectInput, setSelectInput] = React.useState<boolean>(false);
    const [speedSelectInput, setSpeedSelectInput] = React.useState<boolean>(
        false
    );
    const [selectInputPM, setSelectInputPM] = React.useState<boolean>(false);
    const [paymentMethod, setPaymentMethod] = React.useState<any>({
        label: t("payment disabled"),
        value: "3",
    });
    const numberMatchWord = new RegExp(/^[1-9]\d*$/);
    const [designation, setDesignation] = React.useState<string>("");
    const [mark, setMark] = React.useState<string>("");
    const [reference, setReference] = React.useState<string>("");
    const [remarque, setRemarque] = React.useState<string>("");
    const [title, setTitle] = React.useState<string>("");
    const [typeConfig, setTypeConfig] = React.useState<any>("");
    const [typeTerminal, setTypeTerminal] = React.useState<any>("");
    const [identifier, setIdentifier] = React.useState<string>("");
    const [nomTpe, setNomTpe] = React.useState<string>("");
    const [merchantCode, setMerchantCode] = React.useState<string>("");
    const [paymentType, setPaymentType] = React.useState<string>("");
    const [deviceCode, setDeviceCode] = React.useState<string>("");
    const [timeout, setTimeOut] = React.useState<string>("120");
    const [inputTimeout, setInputTimeout] = React.useState<boolean>(false);
    const [url, setUrl] = React.useState<string>("");
    const [port, setPort] = React.useState<any>("8888");
    const [isModalOpened, setIsModalOpened] = React.useState<boolean>(false);
    const [speed, setSpeed] = React.useState<number | string>("");
    const [kiss, setKiss] = React.useState<boolean>(true);
    const [ipAddress, setIpAddress] = React.useState<string>("");
    const [webhook, setWebhook] = React.useState<string>("");
    const isProductionDomain =
        process.env.REACT_APP_API_V2_URL &&
        process.env.REACT_APP_API_V2_URL.includes("etk360");
    const [mode, setMode] = React.useState<string>(
        isProductionDomain ? "Production" : "Test"
    );
    const [InputPort, setInputPort] = React.useState<boolean>(false);
    const [InputCode, setInputCode] = React.useState<boolean>(false);
    const [InputUrl, setInputUrl] = React.useState<boolean>(false);
    const [inputSetupType, setInputSetupType] = React.useState<boolean>(false);
    const [inputTerminalType, setInputTerminalType] = React.useState<boolean>(
        false
    );
    const [inputWebhook, setInputWebhook] = React.useState<boolean>(false);
    const [inputMode, setInputMode] = React.useState<boolean>(false);
    const [canValidate, setCanValidate] = React.useState<boolean>(true);
    const [currency, setCurrency] = React.useState("");
    const [autoValidate, setAutoValidate] = React.useState({
        label: t("True"),
        value: t("True"),
    });
    const [idIntegrator, setIdIntegrator] = React.useState("");
    const [inputCurrency, setInputCurrency] = React.useState<boolean>(false);
    const [inputID, setInputID] = React.useState<boolean>(false);
    const [inputIdIntegrator, setInputIdIntegrator] = React.useState<boolean>(
        false
    );
    const [inputPortAdyen, setInputPortAdyen] = React.useState<boolean>(false);
    const i18nextLng = localStorage.getItem("i18nextLng") || "fr";
    const [keyValue, setKey] = React.useState("");
    const [inputKey, setInputKey] = React.useState(false);
    const [serialNumber, setSerialNumber] = React.useState<any>("");
    const [inputSerialNumber, setInputSerialNumber] = React.useState(false);
    const [communication, setCommunication] = React.useState("Local");

    async function isCurrencyExistInShop(shopId: string) {
        let currencyExist = "";
        const url = `${process.env.REACT_APP_API_V2_URL}/settings/general/devise?userId=${userID}&shopId=${shopId}&franchiseId=${franchiseID}&type=activated`;
        try {
            const result: any = await fetchGlobal<any>(url, {
                method: "GET",
                headers: {
                    "Content-Type": "application/json",
                    "Accept-Language": i18nextLng,
                },
            });
            mutate(url, result);
            if (result.data.length !== 0) {
                if (
                    AdyenCurrencies.find(
                        (el: any) => el.code === result.data[0][t("Currency")]
                    ) !== undefined &&
                    result.data[0].isActive === true
                ) {
                    currencyExist = result.data[0][t("Currency")];
                }
            }
        } catch (error) {
            toast.error(`${t("There's an error")!}`, {
                position: toast.POSITION.TOP_CENTER,
                autoClose: 2000,
                theme: "colored",
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
            });
        }
        return currencyExist;
    }

    const {
        defaultAdyenConfig,
        adyenConfig,
        setAdyenConfig,
        isAutoFill,
        setIsAutoFill,
        IDAdyen,
        selectedIdAdyen,
        setSelectedIdAdyen,
        isShopHasAdyen,
        merchantAccountId,
        setMerchantAccountId,
        isIdExist,
        setIsIdExist,
        isDisabled,
        setIsDisabled,
        adyenIpExist,
        setAdyenIpExist,
    } = useAdyenConfig({
        mark,
        editedData,
        oneShop,
        shopID: shopID as string,
        franchiseID: franchiseID as string,
        selectedRows,
        shopIds,
        tableData,
        isEdited,
        isModalAssociate,
        fetchGlobal,
        isCurrencyExistInShop,
        setIpAddress,
        setPort,
        setWebhook,
        setCurrency,
    });

    async function addMonetics() {
        toast.dismiss();
        let hasIpConflict = 0;
        if (shopIds.length === 0) {
            ErrorToast(`${t("Attention ! you must select a store.")!}`);
        } else if (shopIds.length > 0) {
            if (canValidate) {
                if (
                    (adyenConfig.merchantAccount === undefined ||
                        adyenConfig.merchantAccount === "") &&
                    mark === "Adyen"
                ) {
                    ErrorToast(
                        t(
                            "To add an Adyen payment terminal, you must fill in the fields of the 'Adyen Configuration.'"
                        )
                    );
                } else {
                    let isNotInclude: boolean = false;
                    setCanValidate(false);
                    let localData: any = [];
                    const currencyResults = await Promise.all(
                        shopIds.map((el: string) => isCurrencyExistInShop(el))
                    );
                    for (let i = 0; i < shopIds.length; i++) {
                        const el = shopIds[i];
                        const isCurrencyExist: any = currencyResults[i];
                        if (mark === "MS Solution Tunisie") {
                            let data = buildMsSolutionAddPayload(
                                {
                                    userId: userID,
                                    franchiseId: franchiseID,
                                    operatorId: operatorID,
                                    uuidUser,
                                    designation,
                                    mark,
                                    remarque,
                                },
                                el
                            );
                            const apiUrlAdd = `${process.env.REACT_APP_API_V2_URL}/settings/monetics`;
                            if (
                                moneticIsExistInShop(
                                    el,
                                    data,
                                    tableData,
                                    t("Shop")
                                ) === false
                            ) {
                                localData.push(
                                    fetchGlobal<any>(apiUrlAdd, {
                                        method: "POST",
                                        headers: {
                                            "Content-Type": "application/json",
                                        },
                                        body: JSON.stringify(data),
                                    })
                                );
                            }
                        } else if (
                            (isCurrencyExist !== "" &&
                                mark === "Adyen" &&
                                selectedIdAdyen.value !== "") ||
                            mark !== "Adyen"
                        ) {
                            let data = buildMoneticAddPayload(
                                {
                                    userId: userID,
                                    franchiseId: franchiseID,
                                    operatorId: operatorID,
                                    uuidUser,
                                    designation,
                                    mark,
                                    remarque,
                                    reference,
                                    merchantCode,
                                    deviceCode,
                                    port,
                                    url,
                                    kiss,
                                    speed,
                                    typeConfig,
                                    typeTerminal,
                                    ipAddress,
                                    paymentType,
                                    paymentMethod,
                                    timeout,
                                    webhook,
                                    selectedIdAdyen,
                                    mode,
                                    idIntegrator,
                                    autoValidate,
                                    currency,
                                    adyenConfig,
                                    isAutoFill,
                                    keyValue,
                                    serialNumber,
                                    communication,
                                },
                                el,
                                isCurrencyExist
                            );
                            let filteredData = [...resourceIp]
                                ?.filter(
                                    (item: any) =>
                                        item?.shopId === el &&
                                        item.ip?.trim() !== ""
                                )
                                .map((y: any) => y.ip);
                            filteredData = [...new Set(filteredData)];
                            if (filteredData.includes(ipAddress)) {
                                hasIpConflict++;
                            }
                            const apiUrlAdd = `${process.env.REACT_APP_API_V2_URL}/settings/monetics`;
                            if (
                                moneticIsExistInShop(
                                    el,
                                    data,
                                    tableData,
                                    t("Shop")
                                ) === false
                            ) {
                                localData.push(
                                    fetchGlobal<any>(apiUrlAdd, {
                                        method: "POST",
                                        headers: {
                                            "Content-Type": "application/json",
                                        },
                                        body: JSON.stringify(data),
                                    })
                                );
                            }
                        } else if (isCurrencyExist === "" && mark === "Adyen") {
                            isNotInclude = true;
                        }
                    }

                    try {
                        mutate(
                            `${process.env.REACT_APP_API_V2_URL}/settings/monetics`,
                            await Promise.all(localData).then((result) => {
                                let Err = result.filter(
                                    (x: any) => x.errorMessage !== ""
                                );
                                if (Err.length > 0) {
                                    ErrorToast(t(Err[0].errorMessage));
                                } else if (
                                    result.length !== 0 &&
                                    result.every(
                                        (el: any) => el.error === false
                                    ) &&
                                    localData?.length > 0
                                ) {
                                    toast.success(
                                        `${t(
                                            "The device is successfully added"
                                        )!}`,
                                        {
                                            position: toast.POSITION.TOP_CENTER,
                                            theme: "colored",
                                            toastId: "device-add-success",
                                            icon: (
                                                <CheckboxIcon
                                                    height={25}
                                                    width={25}
                                                    fill="white"
                                                />
                                            ),
                                            autoClose: 5000,
                                            closeOnClick: true,
                                            pauseOnHover: true,
                                            draggable: true,
                                        }
                                    );
                                }
                                if (hasIpConflict > 0) {
                                    setCanValidate(true);
                                    ErrorToast(
                                        t(
                                            "Please note, the device could not be added to one or more stores. Please check the IP address settings."
                                        )
                                    );
                                }
                                setEditedData([]);
                                resetAllPeripherals();
                                setDataIsUpdated!(true);
                                UpdateResourceIp(
                                    userID,
                                    franchiseID,
                                    fetchGlobal
                                );
                                setIsEdited(false);
                                setCanValidate(true);
                            })
                        );
                    } catch (e) {
                        setCanValidate(true);
                        setDataIsUpdated!(true);
                        toast.error(`${t("There's an error" + error)!}`, {
                            position: toast.POSITION.TOP_CENTER,
                            autoClose: 2000,
                            theme: "colored",
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: true,
                        });
                    }

                    if (isNotInclude) {
                        ErrorToast(
                            t(
                                "Caution, the addition could not be successfully completed for one or more stores. Please check the currency settings in the general settings ."
                            )
                        );
                    }
                    setLimit(2);
                }
            }
        }
    }

    async function editMonetics() {
        if (!canValidate) return;

        setCanValidate(false);
        const shopId = oneShop ? shopID : idShop;

        try {
            let dataConfig;

            if (mark === "MS Solution Tunisie") {
                dataConfig = buildMsSolutionEditPayload({
                    userId: userID,
                    franchiseId: franchiseID,
                    operatorId: operatorID,
                    uuidUser,
                    designation,
                    mark,
                    remarque,
                    shopId: shopId as string,
                    peripheralId: identifier,
                });
            } else {
                dataConfig = buildMoneticEditPayload({
                    userId: userID,
                    franchiseId: franchiseID,
                    operatorId: operatorID,
                    uuidUser,
                    designation,
                    mark,
                    remarque,
                    reference,
                    merchantCode,
                    deviceCode,
                    port,
                    url,
                    kiss,
                    speed,
                    typeConfig,
                    typeTerminal,
                    ipAddress,
                    paymentType,
                    paymentMethod,
                    timeout,
                    webhook,
                    selectedIdAdyen,
                    mode,
                    idIntegrator,
                    autoValidate,
                    currency,
                    adyenConfig,
                    isAutoFill,
                    keyValue,
                    serialNumber,
                    communication,
                    shopId: shopId as string,
                    peripheralId: identifier,
                    nomTpe,
                });
            }

            const apiUrlUpdate = `${process.env.REACT_APP_API_V2_URL}/settings/peripheral/modify`;
            const requestOptions = {
                method: "PUT",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify(dataConfig),
            };

            const data = await fetchGlobal<any>(apiUrlUpdate, requestOptions);

            if (data.error) {
                setDataIsUpdated!(true);
                throw new Error("API error");
            }

            mutate(apiUrlUpdate, data);

            toast.success(t("The device is successfully changed")!, {
                position: toast.POSITION.TOP_CENTER,
                theme: "colored",
                toastId: "device-change-success",
                icon: <CheckboxIcon height={25} width={25} fill="white" />,
                autoClose: 5000,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
            });

            setEditedData([]);
            resetAllPeripherals();
            setDataIsUpdated!(true);
            UpdateResourceIp(userID, franchiseID, fetchGlobal);
            setIsAddMoneticsClicked(!isAddMoneticsClicked);
            setIsEdited(false);
        } catch (e) {
            toast.error(t("There's an error")!, {
                position: toast.POSITION.TOP_CENTER,
                autoClose: 2000,
                theme: "colored",
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
            });
            setCanValidate(true);
        }
    }

    async function handleOnChangeMark(e: any) {
        setSelectMark(false);
        setPortSelectInput(false);
        setSpeedSelectInput(false);
        setInputUrl(false);
        setInputSetupType(false);
        setInputTerminalType(false);
        setSelectInput(false);
        setInputCode(false);
        setInputPort(false);
        setInputIp(false);
        setMark(e.value);
        setIsEdited(true);
        setSelectedIdAdyen({ label: "", value: "" });
        setWebhook("");
        if (e.value === "Valina") {
            setPort("");
        } else if (e.value === "Yavin") {
            setPort(5000);
        } else {
            setPort("8888");
        }
        setMerchantCode("");
        setSpeed("");
        setIpAddress("");
        setPaymentType("");
        setUrl("");
        setInputDesignation(false);
        setInputCode(false);
        setInputMode(false);
        setInputWebhook(false);
        setSelectInputPM(false);
        setInputTimeout(!numberPositiveMatch.test(timeout) ? true : false);
        setTypeTerminal("");
        e.value === "Valina"
            ? setReference("EXAMPLE 1")
            : e.value === "Nepting"
            ? setReference("S300")
            : setReference("");
    }

    async function handleValidate() {
        const formData = {
            mark,
            designation,
            reference,
            port,
            speed,
            ipAddress,
            merchantCode,
            url,
            paymentType,
            paymentMethod,
            timeout,
            typeConfig,
            typeTerminal,
            webhook,
            mode,
            idIntegrator,
            currency,
            selectedIdAdyen,
            keyValue,
            serialNumber,
            communication,
            isNameExist,
            isIdExist,
            ipExist,
            shopIds,
            selectInputPM,
            inputTimeout,
            notStartWithSpaceRegExp,
            numberMatchWord,
        };

        const errors = getMoneticsValidationErrors(formData);
        if (errors.selectMark) setSelectMark(true);
        if (errors.inputIp) setInputIp(true);
        if (errors.inputDesignation) setInputDesignation(true);
        if (errors.speedSelectInput) setSpeedSelectInput(true);
        if (errors.portSelectInput) {
            setPortSelectInput(true);
            setInputPortAdyen(true);
            setInputPort(true);
        }
        if (errors.selectInput) setSelectInput(true);
        if (errors.inputCode) setInputCode(true);
        if (errors.inputUrl) setInputUrl(true);
        if (errors.inputWebhook) setInputWebhook(true);
        if (errors.inputMode) setInputMode(true);
        if (errors.selectInputPM) setSelectInputPM(true);
        if (errors.inputTimeout) setInputTimeout(true);
        if (errors.inputTerminalType) setInputTerminalType(true);
        if (errors.inputSetupType) setInputSetupType(true);
        if (errors.inputIdIntegrator) setInputIdIntegrator(true);
        if (errors.inputCurrency) setInputCurrency(true);
        if (errors.inputID) setInputID(true);
        if (errors.inputKey) setInputKey(true);
        if (errors.inputSerialNumber) setInputSerialNumber(true);

        if (isMoneticsFormValid(formData)) {
            if (editedData.Id) {
                if (
                    isEdited === false &&
                    Object.keys(diff(adyenConfig, editedData.adyenConfig))
                        .length === 0
                ) {
                    setIsModalOpened(!isModalOpened);
                } else {
                    await editMonetics();
                }
            } else {
                await addMonetics();
            }
        }
    }

    useEffect(() => {
        if (editedData?.peripheralId !== undefined) {
            setIpExist(
                checkIpIfExist(
                    resourceIp,
                    ipAddress,
                    editedData?.peripheralId,
                    oneShop ? shopID : editedData?.shopId
                )
            );
        } else {
            setIpExist(checkIpIfExist(resourceIp, ipAddress, "", shopID));
        }
        // eslint-disable-next-line
    }, [editedData, ipAddress]);

    useEffect(() => {
        setDesignation("");
        setMark("");
        setRemarque("");
    }, [selectedRows]);

    useEffect(() => {
        if (editedData.Id !== undefined) {
            let designation = paymentMethods.find(
                (elt: any) => elt.value === editedData.payment_method.value
            );
            setIsUpdateOperation(true);
            setDesignation(editedData[t("Designation")]);
            setTitle(
                isConsult === true
                    ? t("View peripheral: monetic")
                    : t("Edit device: monetics")
            );
            setReference(editedData[t(`Reference`)]);
            setMark(editedData[t(`Mark`)]);
            setRemarque(editedData[t(`Remark`)]);
            setIdentifier(editedData.Id);
            setNomTpe(editedData.name_tpe);
            setIpAddress(editedData.ip);
            setMerchantCode(editedData.merchant_code);
            setPort(editedData.port);
            setPaymentType(editedData.payment_type);
            setDeviceCode(editedData.device_code);
            setTypeConfig(editedData.setup_type);
            setTypeTerminal(
                editedData.terminal_type.value === "25"
                    ? {
                          label: t("Automate kiosk (Pre-authorization)"),
                          value: "25",
                      }
                    : editedData.terminal_type.value === "22" ||
                      editedData.terminal_type.label === "Autre"
                    ? { label: t("TPE POS (Debit)"), value: "22" }
                    : editedData.terminal_type
            );
            setUrl(editedData.url);
            setSpeed(editedData.speed);
            setPaymentMethod({
                ...editedData.payment_method,
                label: designation !== undefined ? t(designation.label) : "",
            });
            setTimeOut(
                !numberPositiveMatch.test(editedData.timeout)
                    ? "120"
                    : editedData.timeout
            );
            setSelectInputPM(false);
            setInputDesignation(false);
            setSelectMark(false);
            setSpeedSelectInput(false);
            setPortSelectInput(false);
            setInputCode(false);
            setSelectInput(false);
            setInputUrl(false);
            setInputPort(false);
            setInputSetupType(false);
            setInputTerminalType(false);
            setKiss(editedData.kiss);
            setSelectedIdAdyen({
                value: editedData.adyenIp,
                label: editedData.adyenIp,
            });
            setWebhook(editedData.webhook);
            setMode(editedData.mode);
            setInputMode(false);
            setInputWebhook(false);
            setIdIntegrator(editedData.idIntegrator);
            setAutoValidate(editedData.autoValidate);
            setCurrency(editedData.currency);
            setInputCurrency(false);
            setInputIdIntegrator(false);
            setInputTimeout(false);
            setMerchantAccountId(editedData.adyenConfig.merchantAccount);
            setIsIdExist(false);
            setKey(editedData.key);
            setSerialNumber(editedData.serialNumber);
            setCommunication(editedData.communication);
        } else {
            setIsUpdateOperation(false);
            setDesignation("");
            setTitle(t("Add device: monetics"));
            setReference("");
            setMark("");
            setRemarque("");
            setIdentifier("");
            setNomTpe("");
            setIpAddress("");
            setMerchantCode("");
            setPort("8888");
            setPaymentType("");
            setDeviceCode("");
            setTypeConfig("");
            setTypeTerminal("");
            setSpeed("");
            setTimeOut("120");
            setKiss(true);
            setInputDesignation(false);
            setSelectMark(false);
            setSpeedSelectInput(false);
            setPortSelectInput(false);
            setInputCode(false);
            setSelectInput(false);
            setInputUrl(false);
            setInputSetupType(false);
            setInputTerminalType(false);
            setInputPort(false);
            setSelectInputPM(false);
            setInputTimeout(false);
            // eslint-disable-next-line no-implied-eval
            setTimeout("");
            setInputMode(false);
            setInputWebhook(false);
            setIdIntegrator("");
            setAutoValidate({ label: t("True"), value: t("True") });
            setCurrency("");
            setInputCurrency(false);
            setInputIdIntegrator(false);
            setAdyenConfig(defaultAdyenConfig);
            setMerchantAccountId(defaultAdyenConfig.merchantAccount);
            setIsIdExist(false);
            setKey("");
            setSerialNumber(5000);
            setCommunication("Local");
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        editedData,
        t,
        isAddNewMoneticsButtonClicked,
        oneShop,
        setIsUpdateOperation,
        isConsult,
        setInputDesignation,
        setSelectMark,
    ]);

    React.useEffect(() => {
        let data: any = [];
        let array = [...tableData.data, ...tableData.othersData.dataArchived];
        if (array !== undefined && array?.length > 0) {
            if (shopIds?.length >= 1 && editedData.Id === undefined) {
                if (array[0][t("Shop")] !== undefined) {
                    shopIds.forEach((shopId: any) => {
                        data = [
                            ...data,
                            ...getListMonetics(array, shopId, t("Shop")),
                        ];
                    });
                } else {
                    data = array;
                }
            } else if (editedData.Id !== undefined) {
                if (array[0][t("Shop")] !== undefined) {
                    data = getListMonetics(array, editedData.shopId, t("Shop"));
                } else {
                    data = array;
                }
            }
        }

        let check = checkDesignationIfExist(
            designation,
            data,
            t("Designation")
        );
        if (
            (check === true && editedData.Id === undefined) ||
            (check === true &&
                editedData.Id !== undefined &&
                editedData[t("Designation")].toUpperCase().trim() !==
                    designation.toUpperCase().trim())
        ) {
            setIsNameExist(true);
        } else {
            setIsNameExist(false);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [shopIds, editedData, designation]);

    React.useEffect(() => {
        setIpExist(
            checkIpIfExist(
                resourceIp,
                ipAddress,
                editedData?.Id !== undefined ? editedData?.Id : "",
                editedData?.Id !== undefined
                    ? editedData?.shopId
                    : shopIds.length === 1
                    ? shopIds[0]
                    : ""
            )
        );
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [editedData, shopIds, ipAddress, IDAdyen]);

    React.useEffect(() => {
        if (editedData?.Id === undefined) {
            if (mark === "Adyen") setPort("");
            else if (mark === "Valina") setPort("");
            else if (mark === "Yavin") setPort(5000);
            else setPort("8888");
        }
    }, [mark, editedData]);

    return {
        t,
        isActionsClicked,
        title,
        designation,
        setDesignation,
        mark,
        setMark,
        remarque,
        setRemarque,
        reference,
        setReference,
        isNameExist,
        isModalOpened,
        setIsModalOpened,
        selectMark,
        portSelectInput,
        setPortSelectInput,
        speedSelectInput,
        setSpeedSelectInput,
        selectInputPM,
        setSelectInputPM,
        SelectInput,
        setSelectInput,
        InputPort,
        setInputPort,
        InputCode,
        setInputCode,
        InputUrl,
        setInputUrl,
        inputSetupType,
        setInputSetupType,
        inputTerminalType,
        setInputTerminalType,
        inputWebhook,
        setInputWebhook,
        inputMode,
        setInputMode,
        inputTimeout,
        setInputTimeout,
        inputCurrency,
        setInputCurrency,
        inputID,
        setInputID,
        inputIdIntegrator,
        setInputIdIntegrator,
        inputPortAdyen,
        setInputPortAdyen,
        inputKey,
        setInputKey,
        inputSerialNumber,
        setInputSerialNumber,
        port,
        setPort,
        speed,
        setSpeed,
        kiss,
        setKiss,
        ipAddress,
        setIpAddress,
        webhook,
        setWebhook,
        mode,
        setMode,
        merchantCode,
        setMerchantCode,
        paymentType,
        setPaymentType,
        url,
        setUrl,
        typeConfig,
        setTypeConfig,
        typeTerminal,
        setTypeTerminal,
        timeout,
        setTimeOut,
        paymentMethod,
        setPaymentMethod,
        idIntegrator,
        setIdIntegrator,
        autoValidate,
        setAutoValidate,
        currency,
        setCurrency,
        isIdExist,
        setIsIdExist,
        isDisabled,
        setIsDisabled,
        IDAdyen,
        selectedIdAdyen,
        setSelectedIdAdyen,
        isShopHasAdyen,
        merchantAccountId,
        adyenConfig,
        setAdyenConfig,
        isAutoFill,
        setIsAutoFill,
        adyenIpExist,
        setAdyenIpExist,
        keyValue,
        setKey,
        serialNumber,
        setSerialNumber,
        communication,
        setCommunication,
        paramsTypes,
        list_payment_method,
        speeds,
        ports,
        typeOfConfig,
        typeOfTerminal,
        pathname,
        notStartWithSpaceRegExp,
        numberMatchWord,
        handleOnChangeMark,
        handleValidate,
        resetAllPeripherals,
        setActions,
        setIsActionsClicked,
    };
}
